<template>
  <div class="sidebar" :class="[sidebarCollapsed ? 'collapsed' : 'expand']">
    <scrollbar ref="scrollbar" class="scrollbar-body">
      <div class="management" v-for="(menuitem,index) in menuList" v-bind:key="menuitem.path">
        <div class="sidebar-header" v-if="menuitem.submenu && (model===menuitem.mode || menuitem.mode==='BOTH')">
          <div class="sidebar-item" @click="toggleOpen(index)">
            <div class="sidebar-item-title" :title="$t(menuitem.title)" v-show="!sidebarCollapsed">
              {{$t(menuitem.title)}}
            </div>
            <div class="sidebar-header-icon pull-right">
              <div class="icon" :class="[ menuitem.open? 'icon-arrow_up' : 'icon-arrow_down' ]">
              </div>
            </div>
          </div>
        </div>
        <div class="sidebar-body" v-if="menuitem.submenu && (model===menuitem.mode || menuitem.mode==='BOTH')" :class="[(menuitem.open && !sidebarItemCollapsed)? 'fadein': '']">
          <div class="sidebar-item" :title="$t(submenu.title)" v-bind:key="submenu.path" v-for="submenu in menuitem.submenu" :class="{active: activeMenu(submenu)}" @click="onMenuClick(submenu)">
            <div class="sidebar-item-icon">
              <span :class="getPath(submenu.path)" class="q-icon"/>
            </div>
            <div class="sidebar-item-title" v-show="!sidebarItemCollapsed">
              {{$t(submenu.title)}}
            </div>
          </div>
        </div>
        <div class="sidebar-body fadein" v-if="!menuitem.submenu && (model===menuitem.mode || menuitem.mode==='BOTH')">
          <div class="sidebar-item" :title="$t(menuitem.title)" v-bind:key="menuitem.path" :class="{active: activeMenu(menuitem)}" @click="onMenuClick(menuitem)">
            <div class="sidebar-item-icon" :class="{active: activeMenu(menuitem)}">
              <span :class="getPath(menuitem.path)" class="q-icon"/>
            </div>
            <div class="sidebar-item-title bold" v-show="!sidebarItemCollapsed">
              {{$t(menuitem.title)}}
            </div>
          </div>
        </div>
      </div>
    </scrollbar>
    <div class="toggle-icon" @click="onToggleClick" :class="{collapsed: sidebarCollapsed}"></div>
    <WarningPage :onChange="onChange"></WarningPage>
  </div>
</template>
<script>
import config from '../config'
import WarningPage from './WarningWin'
import {
  mapState,
  mapMutations
} from 'vuex'
export default {
  name: 'sidebar',
  components: {
    WarningPage
  },
  data () {
    return {
      menuList: {}
    }
  },
  watch: {
    selectMenu: function (value) {
      this.$log.info('selectMenu change')
      for (let index in this.menuList) {
        let menu = this.menuList[index]
        if (menu.path === this.$route.name) {
          this.$store.commit('updateMenu', menu)
          return
        } else if (menu.submenu) {
          for (let subIndex in menu.submenu) {
            let submenu = menu.submenu[subIndex]
            if (submenu.path === this.$route.name) {
              this.$store.commit('updateMenu', submenu)
              if (submenu.submenu) {
                menu['open'] = true
                this.$log.info('watch', submenu.submenu[submenu.path])
                this.$store.commit('updateSubMenu', submenu.submenu[submenu.path])
              } else {
                menu['open'] = true
                this.$store.commit('updateSubMenu', '')
              }
              return
            }
          }
        }
      }
    }
  },
  created () {
    this.model = process.env.MODEL
    this.menuList = config.menu
    if (!this.systemHostInfo.SupportPoE) {
      delete this.menuList.CONFIGURE.submenu.POE
    }
    if (!config.productDiff[this.systemHostInfo.Product].isLoopBack) {
      delete this.menuList.CONFIGURE.submenu.LOOPPROTECTION
    }
  },
  beforeMount: function () {
    this.$log.info('beforeMount >>>>')
    for (let index in this.menuList) {
      let menu = this.menuList[index]
      if (menu.path === this.$route.name) {
        this.$store.commit('updateMenu', menu)
        return
      } else if (menu.submenu) {
        for (let subIndex in menu.submenu) {
          let submenu = menu.submenu[subIndex]
          if (submenu.path === this.$route.name) {
            this.$store.commit('updateMenu', submenu)
            if (submenu.submenu) {
              menu['open'] = true
              // let key = Object.keys(submenu.submenu[submenu.alias]
              this.$store.commit('updateSubMenu', submenu.submenu[submenu.alias])
            } else {
              menu['open'] = true
              this.$store.commit('updateSubMenu', submenu)
            }
            return
          } else if (submenu.submenu) {
            for (let childIndex in submenu.submenu) {
              let childmenu = submenu.submenu[childIndex]
              if (childmenu.path === this.$route.name) {
                menu['open'] = true
                this.$store.commit('updateMenu', submenu)
                this.$store.commit('updateSubMenu', childmenu)
                return
              }
            }
          }
        }
      }
    }
  },
  methods: {
    onMenuClick: function (menu) {
      this.$log.debug(menu)
      this.$store.commit('updateNextMenu', menu)
      if (this.isDataChanged) {
        this.$store.commit('updateIsSidebar', true)
        this.openModal('warning-window-modal')
        this.$modal.show('warning-window-modal')
      } else {
        if (this.isSidebar === null || this.isSidebar) {
          this.$store.commit('updateMenu', menu)
          if (menu.submenu) {
            let key = Object.keys(menu.submenu)[0]
            this.$store.commit('updateSubMenu', menu.submenu[key])
          } else {
            // let key = Object.keys(menu.submenu)[0]
            this.$store.commit('updateSubMenu', '')
          }
        } else {
          this.$parent.onMenuClick(this.nextMenu)
        }
        this.$router.push({
          name: menu.path
        })
        this.$store.commit('updateIsSidebar', null)
        this.$forceUpdate()
      }
    },
    onChange: function () {
      this.$store.commit('updateDataChanged', false)
      this.onMenuClick(this.nextMenu)
    },
    toggleOpen: function (index) {
      this.menuList[index]['open'] = !this.menuList[index]['open']
      this.$forceUpdate()
    },
    activeMenu: function (menuitem) {
      if (menuitem.path === this.selectMenu.path) {
        return true
      } else {
        return false
      }
    },
    getPath: function (menupath) {
      let value = null
      switch (menupath) {
        case 'dashboard':
          value = 'dashboard_1'
          break
        case 'portstatus':
          value = 'port_1'
          break
        case 'lldpconfig':
          value = 'lldp'
          break
        case 'igmpsnooping':
          value = 'igmp'
          break
        case 'aclip':
          value = 'acl'
          break
        case 'sysinformation':
          value = 'setting'
          break
        case 'liveupdate':
          value = 'firmware_1'
          break
        case 'portmirroring':
          value = 'port_mirroring'
          return 'icfont-' + value
        case 'poeconsumption':
          value = 'poe'
          return 'icfont-' + value
        case 'loopprotection':
          value = 'loop_protection'
          return 'icfont-' + value
        default:
          value = menupath
          break
      }
      return 'icon-' + value
    },
    // getTooltips: function (title) {
    //   let tooltips = 'menuToolTips.'
    //   if (title !== 'group' || title !== 'configurations' || title !== 'sysmanagement') {
    //     tooltips = tooltips + title
    //     return this.$t(tooltips)
    //   }
    // },
    onToggleClick () {
      this.$store.commit(
        'setSidebarCollapsed',
        !this.$store.state.app.sidebarCollapsed
      )
    },
    ...mapMutations(['openModal'])
  },
  computed: {
    path: function () {
      return this.$store.state.route.path
    },
    ...mapState({
      sidebarItemCollapsed: state => state.app.sidebarItemCollapsed,
      sidebarCollapsed: state => state.app.sidebarCollapsed,
      isAdmin: state => state.app.isAdmin,
      selectMenu: state => state.app.selectMenu,
      subMenu: state => state.app.subMenu,
      isDataChanged: state => state.app.isDataChanged,
      nextMenu: state => state.app.nextMenu,
      isSidebar: state => state.app.isSidebar,
      systemHostInfo: state => state.module.systemHostInfo
    })
  }
}
</script>
<style lang="scss">
.sidebar-header-icon {
  cursor: pointer;
  display: inline-block;
  position: absolute;
  line-height: 40px;
  right: 10px;
  fill: #ffffff;
  >.icon {
    font-size: 20px;
    width: 20px;
    height: 20px;
    margin: 5px 0;
    display: inline-block;
    transition-duration: 0.8s;
    transition-property: transform;
    overflow: hidden;
    &.menu_open {
      -webkit-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      -o-transform: rotate(180deg);
    }
  }
}

.sidebar {
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  transition: width .5s;
  user-select: none;
  margin-right: -10px;
  &.expand {
    width: 230px;
  }
  &.collapsed {
    width: 65px;
    .sidebar-header-icon {
      right: 15px;
    }
  }
  > .management {
    >.header {}
    >.body {}
  }
  .sidebar-create-header {
    height: 45px;
    padding-top: 18px;
    >.sidebar-header-icon {
      text-align: center;
      padding-right: 0;
    }
    >.border-box {
      height: 7px;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      >.short-border {
        width: 28px;
        height: 1px;
        border-bottom: rgba(255, 255, 255, .3) 1px solid;
      }
    }
  }
  .sidebar-header {
    height: 33px;
    line-height: 33px;
    font-family: 'Roboto-R';
    font-size: 12px;
    color: #99A9B8;
    &.none-border-bottom {
      border-bottom: none;
      height: 22px;
      line-height: 22px;
    }
    .sidebar-header-title {
      display: inline-block;
      color: #99A9B8;
      font-size: 14px;
      font-family: 'Roboto-R';
      line-height: 14px;
      margin-top: 22px;
    }
    .sidebar-item {
      height: 33px;
      line-height: 33px;
      position: relative;
      >.sidebar-item-icon {
        fill: #99A9B8;
      }
      >.sidebar-item-title {
        color: #99A9B8;
        line-height: 33px;
        font-family: 'Roboto-R' !important;
        margin-left: 25px;
      }
    } //sidebar-item
  } //sidebar-header
  .sidebar-body {
    .browser-list-top {
      position: absolute;
      top: 0;
      width: 100%;
      height: 30px;
      background-image: linear-gradient(to bottom, rgba(0, 90, 104, 1), rgba(0, 90, 104, 0));
      pointer-events: none;
    }
    -webkit-transition: max-height .6s;
    -moz-transition: max-height .6s;
    -ms-transition: max-height .6s;
    -o-transition: max-height .6s;
    transition: max-height .6s;
    overflow: hidden;
    max-height: 0;
    &.fadein {
      max-height: 500px;
    }
  } //sidebar-body
  .sidebar-item {
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    display: flex;
    min-width: 40px;
    &.active {
      background: #1A8EC7 !important;
      border-left: 5px solid #ffffff;
      >.sidebar-item-icon {
        margin: 0px 0px 0px 20px;
      }
    }
    &:hover {
      background: #115B80;
    }
    >.sidebar-item-icon {
      margin: 0px 0px 0px 25px;
      width: 30px;
      text-align: center;
      fill: #ffffff;
      >.q-icon {
        font-size: 30px;
        cursor: pointer;
        z-index: 10;
        padding: 0;
        border: 0;
        vertical-align: middle;
        background-size: contain;
        &:focus {
          outline: 0;
        }
      }
    }
    >.sidebar-item-title {
      font-size: 14px;
      color: #ffffff;
      line-height: 50px;
      font-weight: 900;
      margin-left: 15px;
      text-overflow: ellipsis;
      overflow: hidden;
      width: calc(100% - 40px);
      max-width: 145px;
      white-space: nowrap;
    }
  } //sidebar-item
  .toggle-icon {
    position: absolute;
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
    right: 15px;
    bottom: 30px;
    width: 30px;
    height: 30px;
    background-image: url("../assets/menu/btn_menu_close_normal.png");
    &:hover {
      background-image: url("../assets/menu/btn_menu_close_hover.png");
    }
    &.collapsed {
      background-image: url("../assets/menu/btn_menu_open_normal.png");
      &:hover {
        background-image: url("../assets/menu/btn_menu_open_hover.png");
      }
    }
  }
  >.scrollContainer {
    height: calc(100% - 70px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue